<template>
  <b-row tag="article" v-if="loading">
    <div class="col text-center">
      <b-spinner label="Spinning"></b-spinner>
    </div>
  </b-row>
  <b-row tag="article" v-else class="m-5">
    <b-col v-for="post in posts" v-bind:key="post.id" lg="3" md="6" sm="12" class="mb-3">
      <div style="background: #f4f4f4;">
        <div
          style="position:relative; position: relative;width: 100%;max-height: 150px;overflow: hidden;"
        >
          <b-img :src="thumbnail(post)" fluid style="width:100%; height:auto" :to="`/noticias/${post.id}`"/>

          <FormatedDate
            class="post-date font-weight-bold"
            format="YYYY-MM-DDTHH:mm:ss"
            :date="post.date"
          />
        </div>
        <div style="padding:15px">
          <b-link :to="`/noticias/${post.id}`" class="text-dark">
            <h3 class="post-block-title" v-html="post.title.rendered" />
          </b-link>
          <div class="post-excerpt" v-html="post.excerpt.rendered" />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import config from "../../public/data/config.json"
//import CategoriesList from "~/components/CategoriesList.vue";
import FormatedDate from "./FormatedDate.vue";
//import ReadMore from "~/components/ReadMore.vue";

export default {
  components: {
    //CategoriesList,
    FormatedDate
    //ReadMore */
  },
  methods: {
    thumbnail(post) {
      if (typeof post._embedded["wp:featuredmedia"] === "undefined") {
        return "https://via.placeholder.com/350x250";
      } else {
        return post._embedded["wp:featuredmedia"]["0"].source_url;
      }
    }
  },
  data() {
    return {
      posts: null,
      loading: false
    };
  },
  async mounted() {
    this.loading = true;
    try {
      const results = await axios.get(
        config.URL+"/posts?_embed&per_page=4&filter[orderby]=date&order=asc"
      );

      this.posts = results.data;
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  }
};
</script>
<style>
.post-block-title {
  height: 55px;
  overflow: hidden;
}
.post-excerpt {
  height: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}
</style>